import { RouteConfig } from 'vue-router';
const routers: RouteConfig[] = [
    {
        path: '*',
        redirect: 'pool'
    },
];
export default routers;

